import { isStringEmptyOrNull } from "../../../../utils/common";
import moment from 'moment';
import { MSG_EMPTY_REQUIRED, MSG_GREATER_ENDDATE, MSG_EXCEEDS_CHARACTER, MSG_NEGATIVE_VALUES, MSG_GREATER_ZERO } from "../../../../utils/messages";
import { ADTYPE_EVENT } from "../../../../utils/constants";

export const validateForm = (values) => {
    let errors = {};

    if (isStringEmptyOrNull(values.AdsModel.adsTitle)) {
        errors[`AdsModel.adsTitle`] = MSG_EMPTY_REQUIRED;
    } else if (255 < values.AdsModel.adsTitle.length) {
        errors[`AdsModel.adsTitle`] = MSG_EXCEEDS_CHARACTER;
    }

    if (isStringEmptyOrNull(values.AdsModel.adsDescription) || "<p></p>\n".toString() === values.AdsModel.adsDescription.toString()) {
        errors[`AdsModel.adsDescription`] = MSG_EMPTY_REQUIRED
    }
    // else if (2500 < values.AdsModel.adsDescription.length) {
    //     errors[`AdsModel.adsDescription`] = MSG_EXCEEDS_CHARACTER;
    // }

    if (moment(values.AdsModel.endDate).isBefore(moment(values.AdsModel.startDate))) {
        errors[`AdsModel.endDate`] = MSG_GREATER_ENDDATE;
    }

    if (0 === (values.AdsModel.redemptionLimit).toString().length) {
        errors[`AdsModel.redemptionLimit`] = MSG_EMPTY_REQUIRED;
    } else if (ADTYPE_EVENT === Number(values.AdsModel.adTypeId) && 0 === Number(values.AdsModel.redemptionLimit)) {
        errors[`AdsModel.redemptionLimit`] = MSG_GREATER_ZERO;
    } else if (0 > Number(values.AdsModel.redemptionLimit)) {
        errors[`AdsModel.redemptionLimit`] = MSG_NEGATIVE_VALUES;
    }

    if (0 === (values.AdsModel.adsPrice).toString().length) {
        errors[`AdsModel.adsPrice`] = MSG_EMPTY_REQUIRED;
    } else if (0 > Number(values.AdsModel.adsPrice)) {
        errors[`AdsModel.adsPrice`] = MSG_NEGATIVE_VALUES;
    }

    return errors;

}